import { PublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";

const getUrl = () => {
    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host;
    return baseUrl;
}

const clientId = process.env.REACT_APP_CLIENTID
    ? process.env.REACT_APP_CLIENTID
    : '';
const scopes = JSON.parse(
    process.env.REACT_APP_SCOPES ? process.env.REACT_APP_SCOPES : '[]'
);
const authority = process.env.REACT_APP_AUTHORITY
    ? process.env.REACT_APP_AUTHORITY
    : '';
const knownAuthorities = JSON.parse(
    process.env.REACT_APP_KNOWNAUTHORITIES
        ? process.env.REACT_APP_KNOWNAUTHORITIES
        : '[]'
);

const config = {
    auth: {
        authority: authority,
        clientId: clientId,
        knownAuthorities: knownAuthorities,
        redirectUri: getUrl()
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true
    }
};

export const loginRequest = {
    scopes: scopes
};

export const pca = new PublicClientApplication(config);
pca.handleRedirectPromise();

export const acquireAccessToken = async () => {
    return new Promise((resolve, reject) => {
        const activeAccount = pca.getActiveAccount();
        const accounts = pca.getAllAccounts();
        const silentRequest = {
            scopes: loginRequest.scopes,
            account: activeAccount || accounts[0],
            redirectUri: getUrl() + "/auth.html"
        };
        const request = {
            scopes: loginRequest.scopes,
            account: activeAccount || accounts[0]
        };

        pca.acquireTokenSilent(silentRequest).then(tokenResponse => {
            resolve(tokenResponse.accessToken);
        }).catch(error => {
            if (error instanceof InteractionRequiredAuthError) {
                console.log("InteractionRequiredAuthError");
                pca.acquireTokenRedirect(request).then((tokenResponse) => {
                    resolve(tokenResponse.accessToken);
                })
            }
            else if (error.toString().indexOf("monitor_window_timeout") > 0) {
                pca.acquireTokenRedirect(request).then((tokenResponse) => {
                    resolve(tokenResponse.accessToken);
                })
            }
            else {
                console.log(error);
                reject();
            }
        });
    });
};


export const isDMGUser = () => {
    var currAcc = GetCurrAccount();
    if (!currAcc) {
        return false;
    }
    return currAcc.idTokenClaims.tid === "02036d9e-e633-44bb-9d07-77f03d3bf44c";
};

export const isViableDMGUser = () => {
    if (isDMGUser) {
        var currAcc = GetCurrAccount();
        if (currAcc && currAcc.idTokenClaims.email !== undefined) {
            return true;
        }
    }
};

export const getCurrentUsername = () => {
    var currAcc = GetCurrAccount();
    if (currAcc) {
        return currAcc.username;
    }
};

function GetCurrAccount() {
    let activeAccount = pca.getActiveAccount();
    let accounts = pca.getAllAccounts();
    if (activeAccount === null && accounts.length === 0) {
        // Don't trigger authentication for adhoc route
        if (window.location.pathname !== '/adhoc') {
            const request = {
                scopes: loginRequest.scopes,
                account: activeAccount || accounts[0]
            };
            pca.acquireTokenRedirect(request);
        }
    }
    return activeAccount || accounts[0];
}